import React from "react";
import { browserHistory } from "react-router";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";

export default class PeopleAccrualDisclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            body: "",
            createTimeOffLabel: "",
            viewTimeOffLabel: ""
        }
        this.role = context.getRouteParam(this, "role");
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
        this.gotoPtoCreate = this.gotoPtoCreate.bind(this);
    }

    componentDidMount() {
        let self = this;
        ajax.vm()
            .get('pto/disclaimer')
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    body: res.data.body,
                    createTimeOffLabel: res.data.createTimeOffLabel,
                    createTimeOffMobileLabel: res.data.createTimeOffMobileLabel,
                    viewTimeOffLabel: res.data.viewTimeOffLabel
                });
            })
            .catch(function (err) {
                let data = err.response? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                }, self.close);
            });
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    gotoPtoCreate() {
        browserHistory.push(context.routeUrl("people/accrual-balance/create"));
    }

    render() {
        const self = this;
        const isMobile = this.isIos() || this.isAndroid();
        const createTimeOffLabel = isMobile? this.state.createTimeOffMobileLabel : this.state.createTimeOffLabel;

        return (
            <div className="container ap-pto-disclaimer">
               <div className="row">
                    <div className="col-xs-12 col-md-12 title">
                        {this.state.title}
                    </div>
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <div className="sub-title ap-text-bold">
                            <a href={context.routeUrl("people/accrual-balance")}>
                                {this.state.viewTimeOffLabel}
                                <i className="fa fa-angle-right ap-ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className={isMobile? "row" : "hide"}>
                    <div className="col-xs-12 col-md-8 col-md-offset-2 ap-mt-1">
                        <button className="btn btn-selected ap-fullsize" onClick={this.gotoPtoCreate}>
                            <div dangerouslySetInnerHTML={ { __html: createTimeOffLabel } } />
                            <div>
                                <i className="fa fa-angle-right ap-ml-1"></i>
                            </div>
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <div className="body" dangerouslySetInnerHTML={ { __html: self.state.body } } />
                    </div>
                </div>
                <div className={isMobile? "hide" : "row"}>
                    <div className="col-xs-12 col-md-8 col-md-offset-2 ap-mt-1">
                        <button className="btn btn-selected ap-fullsize" onClick={this.gotoPtoCreate}>
                            <div dangerouslySetInnerHTML={ { __html: createTimeOffLabel } } />
                            <div>
                                <i className="fa fa-angle-right ap-ml-1"></i>
                            </div>
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-8 col-md-offset-2 ap-mt-1">
                        <div className="sub-title ap-text-bold">
                            <a href={context.routeUrl("people/accrual-balance")}>
                                {this.state.viewTimeOffLabel}
                                <i className="fa fa-angle-right ap-ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
